import { AGENT_INSTRUCTION_MAX_LENGTH } from '@/pages/agents/constants';
import { useAgentEditorStore } from '@/state/root';
import { AgentCreateTabType } from '@d-id/types';
import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';
import { CharCounterContainer, MultiLineInput } from '../../common/input';

export const Instructions = observer(() => {
    const agentEditorStore = useAgentEditorStore();

    const isPromptLimitReached = useMemo(() => {
        return (agentEditorStore.llm.instructions ?? '').length > AGENT_INSTRUCTION_MAX_LENGTH;
    }, [agentEditorStore.llm.instructions]);

    return (
        <MultiLineInput
            error={!!isPromptLimitReached}
            textTooLong={isPromptLimitReached}
            multiline
            rows={4}
            placeholder={`What does your agent do? How should it behave? What should it not do?`}
            value={agentEditorStore.llm.instructions}
            onChange={e => {
                agentEditorStore.setLLM(prev => ({ ...prev, instructions: e.target.value }));
                agentEditorStore.setErrorTabs(prev => prev.filter(tab => tab !== AgentCreateTabType.Details || isPromptLimitReached));
            }}
            helperText={
                <CharCounterContainer textTooLong={isPromptLimitReached}>
                    {(agentEditorStore.llm.instructions ?? '').length}/{AGENT_INSTRUCTION_MAX_LENGTH}
                </CharCounterContainer>
            }
            data-hj-allow
        />
    );
});
